export default __webpack_public_path__ + "static/media/12790.94ddf091.png";